import { render, staticRenderFns } from "./GP.vue?vue&type=template&id=4eaa03dc&scoped=true"
import script from "./GP.vue?vue&type=script&lang=js"
export * from "./GP.vue?vue&type=script&lang=js"
import style0 from "./GP.vue?vue&type=style&index=0&id=4eaa03dc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaa03dc",
  null
  
)

export default component.exports